import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, AlertController, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
//import { Storage } from '@ionic/storage';
import { EmailValidator } from '../../validators/email';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { AdminProvider } from '../../providers/admin/admin';

import * as moment from 'moment';

@IonicPage()
@Component({
  selector: 'page-user-add-admin',
  templateUrl: 'user-add-admin.html',
})
export class UserAddAdminPage {
  public max = new Date();
  myForm: FormGroup;
  loading: Loading;
  coaches: any[];

  constructor(public admin: AdminProvider, dateTimeAdapter: DateTimeAdapter<any>, public navCtrl: NavController, public navParams: NavParams, public formBuilder: FormBuilder, public afAuth: AngularFireAuth, public alertCtrl: AlertController, public loadingCtrl: LoadingController, private afs: AngularFirestore, public toastCtrl: ToastController) {
    dateTimeAdapter.setLocale('es-ES'); // change locale to spanish
    this.myForm = this.formBuilder.group({
      type: [1, Validators.required],
      name: ['', Validators.required],
      lastName: ['', Validators.required],
      sex: [''],
      email: ['', [Validators.required, EmailValidator.isValid]],
      email2: ['', [EmailValidator.isValid]],
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(12)]],
      password2: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(12)]],
      dob: [''],
      company: ['Gepp'],
      ocupation: ['director'],
      phone: [''],
    });
    this.afs.collection("Users").ref.where("type", "==", 3).where("status", "==", 1).orderBy("uppercaseName", "asc").get().then(collection => {
      this.coaches = collection.docs.map(document => {
        const data = document.data();
        const id = document.id;
        return { id, ...data }
      });
    });
  }

  onSubmit() {
    this.presentLoadingCustom();
    if (this.myForm.value.dob) {
      this.myForm.value.dob = moment(this.myForm.value.dob).format("YYYY-MM-DD");
    }
    this.afAuth.auth.currentUser.getIdToken(true).then((idToken) => {
      let myData = {
        dob: this.myForm.value.dob,
        assignments: 0,
        company: this.myForm.value.company,
        email: String(this.myForm.value.email).toLowerCase(),
        email2: String(this.myForm.value.email2).toLowerCase(),
        name: this.myForm.value.name,
        lastName: this.myForm.value.lastName,
        uppercaseName: String(this.myForm.value.lastName + " " + this.myForm.value.name).toLocaleUpperCase(),
        ocupation: this.myForm.value.ocupation,
        phone: this.myForm.value.phone,
        sex: this.myForm.value.sex,
        type: Number(this.myForm.value.type),
        status: 1,
        isNewUser: true,
        profile: { downloadURL: 'https://firebasestorage.googleapis.com/v0/b/coachingretirement-bf8e3.appspot.com/o/assets%2Fuserret.jpg?alt=media&token=a54cc3ad-d259-477e-8b7a-72feac02fbe7' }
      }
      this.admin.createAccount(idToken, (String(this.myForm.value.password)), myData).toPromise().then((response) => {
        if (response['success'] == true) {
          this.loading.dismiss();
          this.navCtrl.pop();
          this.presentToast('Agregado correctamente');
        } else {
          this.loading.dismiss();
          this.presentToast('Ha ocurrido un error');
        }
      }).catch(() => {
        this.loading.dismiss();
        this.presentToast('Ha ocurrido un error');
      });
    }).catch(() => {
      this.loading.dismiss();
      this.presentToast('Ha ocurrido un error');
    });
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  cancel() {
    this.navCtrl.pop();
  }

}


// WEBPACK FOOTER //
// ./src/pages/user-add-admin/user-add-admin.ts